<template>
  <div class="work-history section">
    <h2 class="section-title">
      <span class="icon"><i class="mdi mdi-briefcase"></i></span>
      Work Experience
    </h2>

    <div class="timeline">
      <div
        v-for="(job, index) in workHistory"
        :key="index"
        class="timeline-item"
      >
        <div class="timeline-marker"></div>
        <div class="timeline-content">
          <div class="job-header">
            <h3 class="job-position">{{ job.position }}</h3>
            <span class="job-company">{{ job.company }}</span>
            <span class="job-dates">{{ formatJobDates(job, index) }}</span>
          </div>
          <p class="job-description">{{ job.description }}</p>
          <!-- <div class="job-accomplishments" v-if="job.accomplishments && job.accomplishments.length > 0">
            <h4 class="accomplishments-title">Key Accomplishments:</h4>
            <ul class="accomplishments-list">
              <li v-for="(accomplishment, i) in job.accomplishments" :key="i">
                {{ accomplishment }}
              </li>
            </ul>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkExperienceTimeline',
  props: {
    workHistory: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) {
        return '';
      }
      return this.$moment.utc(dateString).format('M/YYYY');
    },
    formatJobDates(job, index) {
      if ((!job.startDate || job.startDate === '') && index === 0) {
        return 'Current employer';
      }

      const start = this.formatDate(job.startDate) || 'N/A';
      const end = job.endDate ? this.formatDate(job.endDate) : 'Present';
      return `${start} - ${end}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
}

.section-title {
  display: flex;
  align-items: center;
  color: $color-text;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid $color-border-muted;

  .icon {
    margin-right: 12px;
    color: $color-primary;
  }
}

.timeline {
  position: relative;
  margin: 1rem 0 0 0;
  padding-left: 2rem;

  &:before {
    content: '';
    position: absolute;
    left: 7px;
    top: 0;
    height: 100%;
    width: 2px;
    background: $color-border;
  }

  .timeline-item {
    position: relative;
    margin-bottom: 2.5rem;

    &:last-child {
      margin-bottom: 0;
    }

    &:last-child:before {
      height: 50%;
    }
  }

  .timeline-marker {
    position: absolute;
    left: -2rem;
    top: 4px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid $color-primary;
    background: white;
    z-index: 1;
  }

  .timeline-content {
    padding-bottom: 1rem;
  }

  .job-header {
    margin-bottom: 1rem;

    .job-position {
      font-size: 1.25rem;
      font-weight: 700;
      color: $color-text;
      margin: 0 0 0.5rem 0;
    }

    .job-company {
      font-size: 1.1rem;
      font-weight: 600;
      color: $color-primary;
      margin-right: 1rem;
    }

    .job-dates {
      font-size: 0.9rem;
      color: $color-text-subtle;
    }
  }

  .job-description {
    color: $color-text-muted;
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  .job-accomplishments {
    background-color: rgba(239, 191, 65, 0.3);
    border-radius: 6px;
    padding: 1rem 1.5rem;

    .accomplishments-title {
      font-size: 1rem;
      font-weight: 600;
      color: $color-text;
      margin: 0 0 0.5rem 0;
    }

    .accomplishments-list {
      margin: 0;
      padding-left: 1.5rem;

      li {
        margin-bottom: 0.5rem;
        line-height: 1.5;
        color: $color-text-muted;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .timeline {
    padding-left: 1.5rem;

    .timeline-marker {
      left: -1.5rem;
    }
  }
}
</style>
